import * as React from 'react';
import { ToastOptions, toast } from 'react-toastify';
import { MdClose } from 'react-icons/md';
import { IconBaseProps } from 'react-icons';
import { ToastOptionsMessage, ToastPosition, ToastType } from 'ui/constants';
import styles from './toast-factory.scss';

const CustomCloseButton = (toastProps: IconBaseProps) => {
  const { ...validProps } = toastProps;
  return <MdClose {...validProps} />;
};

const wrapToastMessage = (message: ToastOptionsMessage) => {
  if (typeof message === 'function') {
    const renderMessage = message;

    return () => <div className={styles.toastBody}><div>{renderMessage()}</div></div>;
  }

  return <div className={styles.toastBody}><div>{message || ''}</div></div>;
};

export enum AutoCloseDuration {
  Default = 5000,
  Longer = 10000
}

const defaultConfiguration: ToastOptions = {
  position: ToastPosition.TOP_LEFT,
  autoClose: AutoCloseDuration.Default,
  closeButton: <CustomCloseButton size={22} />
};

export const toastFactory = (configuration?: ToastOptions) => {
  let toastId = null;

  const config: ToastOptions = { ...defaultConfiguration, ...configuration };

  return {

    dispatchInfo: (message: string) => toastId = toast(wrapToastMessage(message), {
      ...config,
      type: ToastType.INFO,
      className: `${styles.toastContainer} ${styles.infoToast}`,
      progressClassName: styles.infoToastProgress
    }),

    dispatchSuccess: (message: string) => toastId = toast(wrapToastMessage(message), {
      ...config,
      type: ToastType.SUCCESS,
      className: `${styles.toastContainer} ${styles.successToast}`,
      progressClassName: styles.successToastProgress
    }),

    dispatchError: (message: string) => toastId = toast(wrapToastMessage(message), {
      ...config,
      type: ToastType.ERROR,
      className: `${styles.toastContainer} ${styles.errorToast}`,
      progressClassName: styles.errorToastProgress
    }),

    
    dispatchWarning: (message: string) => toastId = toast(wrapToastMessage(message), {
      ...config,
      type: ToastType.WARNING,
      className: `${styles.toastContainer} ${styles.warningToast}`,
      progressClassName: styles.warningToastProgress
    }),

    updateSuccess: (message: ToastOptionsMessage) => {
      return toastId && toast.update(toastId, {
        ...config,
        type: ToastType.SUCCESS,
        className: `${styles.toastContainer} ${styles.successUpdateToast}`,
        hideProgressBar: true,
        render: wrapToastMessage(message)
      });
    },

    updateError: (message: ToastOptionsMessage) => {
      return toastId && toast.update(toastId, {
        ...config,
        type: ToastType.ERROR,
        className: `${styles.toastContainer} ${styles.errorToast}`,
        progressClassName: styles.errorToastProgress,
        render: wrapToastMessage(message)
      });
    },

    close: () => {
      return toastId && toast.dismiss(toastId);
    }
  };
};
